<template>
 <v-runtime-template :template="template"></v-runtime-template>
</template>
<script>
import VRuntimeTemplate from "vue3-runtime-template";
import $ from "jquery";
import axios from "axios";
import { useRoute, useRouter } from "vue-router";
axios.defaults.withCredentials = true;

// 添加请求拦截器，自动添加认证 token
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("auth_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
export default {
 name: "BottomView",
 data() {
  var res = this.$globalVariable['res'];
  return {
   v: this,
   w: window,
   h: axios,
   template: "",
   template_name: "",
   res: res,
   route: useRoute(),
   router: useRouter(),
  };
 },
 components: {
  VRuntimeTemplate,
 },
 watch: {
  // Watch for route changes
  $route() {
   this.reload();
   if(window.DEBUG)console.log("bottomview_route_reload");
   $("#bottomview_route_reload").click();
  },
 },
 methods: {
  jQuery(selectort) {
   return $(selectort);
  },
  refresh() {
   this.$router.go(this.$router.currentRoute);
  },
           saveStorage(a, b) {
    // 如果是 null 或字符串 'null'，删除该键
    if (b === null || b === 'null') {
      delete this.$globalVariable[a];
      localStorage.removeItem(a);
    } else {
      this.$globalVariable[a] = b;
      if (typeof b === 'object') {
        localStorage.setItem(a, JSON.stringify(b));
      } else {
        localStorage.setItem(a, b);
      }
    }
   },
     getStorage(a) {
    if (!localStorage.getItem(a)) return this.$globalVariable[a];
    var b = localStorage.getItem(a);
    if (b) {
      // 如果存储的是字符串 "null"，返回 null
      if (b === 'null') {
        return null;
      }
      // 尝试解析为 JSON，如果失败则直接返回原始值
      try {
        const parsed = JSON.parse(b);
        // 如果解析成功且是对象，返回解析后的值
        if (typeof parsed === 'object' && parsed !== null) {
          return parsed;
        }
        // 如果解析成功但不是对象，返回原始值（可能是数字或字符串）
        return b;
      } catch (e) {
        // 如果解析失败，直接返回原始值
        return b;
      }
    }
    return b;
   },
  reload() {
  var res = this.$globalVariable['res'];
   var index = res.route.findIndex((x) => x.name == this.$route.name);
   if (
    index > -1 &&
    res.route[index].bottom &&
    res.route[index].bottom in res.templates
   ) {
    if (this.template_name != res.route[index].bottom) {
     this.template_name = res.route[index].bottom;
     this.template = res.templates[res.route[index].bottom].content;
     setTimeout(() => {
      if(window.DEBUG)console.log("bottomview_template_changed");
      $("#bottomview_template_changed").click();
     }, 250);
    }
   }
   else
   {
     this.template_name = "";
     this.template = "";
   }
  },
 },
 mounted: function () {
  this.reload();
  if(window.DEBUG)console.log("bottomview_load");
  $("#bottomview_load").click();
 },
};
</script>